<template>
  <div class="form-actions">
    <div v-if="showSubmitOnFirstTab">
      <save-button />
      <save-close-button />
      <cancel-button />
      <preview-button />
      <submit-button />
    </div>
    <div v-else>
      <pay-button v-if="prepaymentRequired" />
      <save-next-button v-else />
      <cancel-button />
    </div>
    <status />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CancelButton from './CancelButton';
import SaveButton from './SaveButton';
import SaveNextButton from './SaveNextButton';
import SubmitButton from './SubmitButton';
import Status from './Status';
import SaveCloseButton from './SaveCloseButton';
import PreviewButton from './PreviewButton';
import PayButton from './PayButton';

export default {
  inject: ['lang'],
  components: {
    SaveCloseButton,
    Status,
    CancelButton,
    SaveButton,
    SaveNextButton,
    SubmitButton,
    PreviewButton,
    PayButton
  },
  computed: {
    showSubmitOnFirstTab() {
      return !this.prepaymentRequired && !this.hasMultipleTabs;
    },
    prepaymentRequired() {
      return this.prepaymentWasRequired && !this.isManager;
    },
    ...mapState('entryForm', ['isManager']),
    ...mapState('entryFormButtons', {
      prepaymentWasRequired: 'prepaymentRequired'
    }),
    ...mapGetters('entryForm', ['hasMultipleTabs'])
  }
};
</script>
